import { AuthenticatedTemplate, UnauthenticatedTemplate } from "@azure/msal-react";
import { enUS } from "@mui/material/locale";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import "assets/css/styles.scss";
import ConfirmModal from "components/ConfirmModal";
import LoadingFullScreen from "components/LoadingFullScreen";
import ToastNotification from "components/ToastNotification";
import COLORS from "consts/colors";
import Login from "pages/Login";
import { Provider } from "react-redux";
import { BrowserRouter as Router } from "react-router-dom";
import { store } from "redux/store";
import routes, { renderRoutes } from "routers/routes";
import "./App.css";
import { AuthProvider } from "./contexts/JWTAuthContext";

const theme = createTheme(
  {
    palette: {
      mode: "light",
      success: {
        main: COLORS.BC_GREEN,
      },
      warning: {
        main: COLORS.BC_YELLOW,
      },
      error: {
        main: COLORS.BC_RED,
      },
      info: {
        main: COLORS.TEXT,
      },
    },
  },
  enUS
);

function App() {
  return (
    <Provider store={store}>
      <ThemeProvider theme={theme}>
        <AuthenticatedTemplate>
          <LocalizationProvider dateAdapter={AdapterMoment}>
            <Router>
              <AuthProvider>{renderRoutes(routes)}</AuthProvider>
            </Router>
          </LocalizationProvider>
          <ConfirmModal />
          <ToastNotification />
          <LoadingFullScreen />
        </AuthenticatedTemplate>

        <UnauthenticatedTemplate>
          <Login />
        </UnauthenticatedTemplate>
      </ThemeProvider>
    </Provider>
  );
}

export default App;
